// extracted by mini-css-extract-plugin
module.exports = {"textareabox":"fromTextArea_textareabox_H1jqN"};